module.exports = __webpack_public_path__ + "static/media/iPhone33.e3086c21.png";